import { MessageRole } from "../hooks/chatting/backend/types";

export const roleMap: Record<MessageRole, string> = {
  'assistant': 'Aurora Borea',
  'user': 'user',
}